import { useContext, useEffect, useMemo, useState } from "react";
import { VisibilityOutlined } from "@mui/icons-material";
import ProductOptions from "./ForOrderOptions/ProductOptions";
import { CurrentPContext, MasterContext, OrderContext } from "../../ContextApi/context";
import TheMount from "../../OrderSettings/TheMount";
import ConnUrls from "../../Connections/ConnectURL";
import ProductComboOptions from "./ForOrderOptions/ProductComboOptions";
import TheWeightSelect from "../../OrderSettings/TheWeightSelect";
import OrderFunctions from "../../OrderSettings/OrderFunctions";
import ProductIngredientsView from "./ProductIngredientsView";

const ProductItemMarket = (props) => {

    const [order, setOrder] = useContext(OrderContext);
    const [master] = useContext(MasterContext);
    const [currentPage, setCurrentPage] = useContext(CurrentPContext);

    const [imInOrder, setImInOrder] = useState(false);
    const [popMeUp, setPopMeUp] = useState({ timestamp: 0, itemId: null });
    const [inOrderIndex, setInOrderIndex] = useState(-1);
    const [duplicates, setDuplicates] = useState([]);
    const [showIngredients, setShowIngredients] = useState(false);
    const isOutOfStock = !props.divitm.inStock || false;

    const hasIngredients = useMemo(() => {
        try {
            const p = JSON.parse(props.divitm.moreProductDetails);
            return !!p && typeof p === 'object' && !Array.isArray(p);
        } catch (e) { return false; }
    }, [props.divitm.moreProductDetails]);

    let specials = [];
    let addsPrice = 0;

    // בדיקה אם המוצר בהזמנה
    useEffect(() => {
        let chkInOrder = (order.restId == currentPage._id);
        if (chkInOrder) {
            let getItm = order.Orders.findIndex(
                el => el.ordProdID == props.itemId &&
                    (el.orderDiviId == props.divitm._id || props.divitm._id.ObjectId))

            if (getItm != -1) {
                if (!imInOrder) {
                    setInOrderIndex(getItm);
                    setImInOrder(true);
                }
            } else {
                if (imInOrder) {
                    setImInOrder(false);
                    setInOrderIndex(-1);
                }
            }
        }
    }, [order]);

    // מעדכן עלות תוספות ואופציות מיוחדות למנה שלא הוזמנה עדיין
    const tempOrderProds = (prods, calculatedAddsPrice) => {
        let tempAddsPrice = 0;

        // אם קיבלנו מחיר מחושב - השתמש בו
        if (calculatedAddsPrice !== undefined) {
            tempAddsPrice = calculatedAddsPrice;
        } else {
            // אחרת חשב בעצמך עם itmsMount
            prods.map((item) => {
                item.spec.map((prc) => {
                    tempAddsPrice = parseInt(tempAddsPrice) +
                        (parseInt(prc.addToPrice != "" ? prc.addToPrice : 0) * parseInt(prc.itmsMount || 1));
                })
            })
        }

        specials = prods;
        addsPrice = tempAddsPrice;
    }

    // הוספת עוד מוצר זהה מתחת (רק ויזואלית, לא נכנס להזמנה)
    const addDuplicate = () => {
        // סגור את החלון הנוכחי
        setPopMeUp({ timestamp: 0, itemId: null });

        // יצירת ID ייחודי למוצר החדש
        const newItemId = `${props.itemId}_dup_${Date.now()}`;

        // עושה deep copy של המוצר כדי שהאופציות יהיו עצמאיות
        let newDivItem = JSON.parse(JSON.stringify(props.divitm));

        // מנקה את כל הבחירות שנעשו
        if (newDivItem.prodOptions) {
            newDivItem.prodOptions = newDivItem.prodOptions.map(opt => ({
                ...opt,
                selected: Array.isArray(opt.selected) ? [] : 0
            }));
        }

        // הוספת ProductItem חדש למערך - ללא autoOpenOptions!
        setDuplicates([...duplicates,
        <ProductItemMarket
            key={newItemId}
            itemId={newItemId}
            divitm={newDivItem}
            doDeliver={props.doDeliver}
            doTakeAway={props.doTakeAway}
            onlyPhone={props.onlyPhone}
            myClass=""
            smallMarketCss={props.smallMarketCss}
        />
        ]);

        // מוסיף את המוצר החדש להזמנה ופותח את החלון שלו
        setTimeout(() => {
            // הוסף להזמנה
            let tmp = {
                ordProdID: newItemId,
                productName: props.divitm.prodName,
                prodImageUrl: props.divitm.prodImageUrl,
                prodPrice: props.divitm.prodPrice,
                addsPrice: 0,
                specials: [],
                mount: 1,
                weightValue: props.divitm.isWeightAbleProduct
                    ? parseInt(props.divitm.weightValue)
                    : undefined,
                baseWeightValue: props.divitm.isWeightAbleProduct
                    ? parseInt(props.divitm.weightValue)
                    : undefined,
                orderItemId: newItemId,
                cashRegMakat: props.divitm.cashRegMakat,
                orderDiviId: props.divitm._id,
                isCombo: props.divitm.isCombo ? props.divitm.isCombo : false,
                chkProdSauces: props.divitm.chkProdSauces ? props.divitm.chkProdSauces : false,
                chkProdValSauces: props.divitm.chkProdValSauces ? props.divitm.chkProdValSauces : "",
                prodInfo: props.divitm.prodInfo || "",
                unitPrice: props.divitm.unitPrice
            };

            order.Orders.push(tmp);
            setOrder({ ...order });

            // פתח את החלון של המוצר החדש
            setPopMeUp({ timestamp: Date.now(), itemId: newItemId });
        }, 150);
    }

    // פעם ראשונה נלחץ על כפתור ההזמנה
    const firstTimeOrdClick = () => {
        if (isOutOfStock) return;

        setImInOrder(true);
        addToOrder();
        popIT();
    }

    // מוסיף את האובייקט לרשימת ההזמנות
    const addToOrder = () => {
        let tmp = {
            ordProdID: props.itemId,
            productName: props.divitm.prodName,
            prodImageUrl: props.divitm.prodImageUrl,
            prodPrice: props.divitm.prodPrice,
            addsPrice: addsPrice,
            specials: specials,
            mount: 1,
            weightValue: props.divitm.isWeightAbleProduct
                ? parseInt(props.divitm.weightValue)
                : undefined,
            baseWeightValue: props.divitm.isWeightAbleProduct
                ? parseInt(props.divitm.weightValue)
                : undefined,
            orderItemId: props.itemId,
            cashRegMakat: props.divitm.cashRegMakat,
            orderDiviId: props.divitm._id,
            isCombo: props.divitm.isCombo ? props.divitm.isCombo : false,
            chkProdSauces: props.divitm.chkProdSauces ? props.divitm.chkProdSauces : false,
            chkProdValSauces: props.divitm.chkProdValSauces ? props.divitm.chkProdValSauces : "",
            prodInfo: props.divitm.prodInfo || "",
            unitPrice: props.divitm.unitPrice
        };

        // רשת ביטחון מפני סל מעורב: אם הסל עדיין שייך לעסק אחר, פותחים סל
        // חדש במקום לערבב מוצרים משני עסקים תחת הזמנה אחת.
        // בזרימה תקינה הלקוח כבר נשאל על כך בכניסה לעמוד (RestaurantPage).
        if (OrderFunctions.cartBelongsToOtherRest(order, currentPage._id)) {
            order.Orders = [];
        }

        order.Orders.push(tmp);
        setInOrderIndex(order.Orders.length - 1);

        order.restId = currentPage._id;
        order.restName = currentPage.buissName;
        order.GoogleLink = currentPage.GoogleLink;
        setOrder({ ...order });
    }

    // הסרה מהזמנה
    const removeFromOrder = (ordItmId) => {
        setImInOrder(false);
        setPopMeUp({ timestamp: Date.now(), itemId: props.itemId });

        let filt = order.Orders.filter(itm => itm.orderItemId != ordItmId)
        order.Orders = filt;

        setOrder({ ...order })
    }

    // פתיחת חלון האופציות
    const popIT = () => {
        setPopMeUp({ timestamp: Date.now(), itemId: props.itemId });
    }

    // תצוגת המוצר - סופרמרקט
    const smDisp = () => {
        let imgLnk = `${(props.divitm.prodImageUrl != null && props.divitm.prodImageUrl != "") ? props.divitm.prodImageUrl
            : (currentPage.mnuItemMainImg != null && currentPage.mnuItemMainImg != "") ? currentPage.mnuItemMainImg : ""}`
        imgLnk = (imgLnk != "") ? ConnUrls.media(imgLnk) : "";

        return (
            <div id={`prodBlockS_${props.itemId}`}
                className={`superMktProd grayFrame prodSmall ${props.smallMarketCss || ""}`}
                role="button"
                tabIndex={0}
                onClick={(e) => {
                    if (isOutOfStock) return;
                    // אם הקליק בא מתוך הפופאפ, אל תעשה כלום
                    if (e.target.closest('.prodOptions') ||
                        e.target.closest('.prodComboOptions') ||
                        e.target.closest('.prodEyeBtn')) {
                        return;
                    }

                    if (imInOrder && props.divitm.prodOptions.length > 0) {
                        e.stopPropagation();
                        setPopMeUp({ timestamp: Date.now(), itemId: props.itemId });
                    } else {
                        popIT();
                    }
                }}
                onKeyDown={(e) => {
                    if (e.key !== 'Enter' && e.key !== ' ') return;
                    if (isOutOfStock) return;
                    if (e.target.closest('.prodOptions') ||
                        e.target.closest('.prodComboOptions') ||
                        e.target.closest('.prodEyeBtn')) {
                        return;
                    }
                    e.preventDefault();
                    if (imInOrder && props.divitm.prodOptions.length > 0) {
                        setPopMeUp({ timestamp: Date.now(), itemId: props.itemId });
                    } else {
                        popIT();
                    }
                }}>
                {hasIngredients && (
                    <button className="prodEyeBtn" aria-label="הצג מרכיבים" onClick={(e) => { e.stopPropagation(); setShowIngredients(true); }}>
                        <VisibilityOutlined aria-hidden="true" />
                    </button>
                )}
                {
                    imgLnk != "" &&
                    <div className={`prodImageWrap prodImageWrapSmall`}>
                        <img className={"prodImage posUnset"} src={imgLnk}
                            onClick={() => { }} alt={currentPage.altTags || currentPage.pageName || ""} />
                    </div>
                }

                <div className={"prodDetails"}>
                    <div className={`MyFont mnuDivPrdcbold MbigFont`}>
                        {props.divitm.prodName}
                        {(imInOrder) &&
                            <>
                                <div className={"imInOrdBtn"}> אני בהזמנה </div>
                                <div className="dskMountItm">
                                    {props.divitm.isWeightAbleProduct ? (
                                        <div className="plusMinMobile">
                                            <TheWeightSelect
                                                itemId={props.itemId}
                                                weightValue={props.divitm.weightValue}
                                                remFromOrder={() => removeFromOrder(props.itemId)}
                                            />
                                        </div>
                                    ) : (
                                        <div className="plusMinMobile">
                                            <TheMount
                                                itemId={props.itemId}
                                                remFromOrder={() => removeFromOrder(props.itemId)}
                                            />
                                        </div>
                                    )}
                                </div>
                            </>
                        }
                    </div>

                    <div className={"prodDetailsLong spaceTopBig"}>
                        <div className={"mnuDivPrdcReg"}>{props.divitm.prodInfo}</div>
                    </div>

                    {props.divitm.unitPrice &&
                        <div className={"prodDetailsLong"}>
                            <div className={"mnuDivPrdcReg"}> ₪{props.divitm.unitPrice}</div>
                        </div>
                    }

                    {((!master.blockDeliverys.block || !master.blockPickUps.block) &&
                        props.divitm.okToDeliver && !isOutOfStock) ?
                        <>
                            {(imInOrder) ?
                                props.divitm.isCombo ?
                                    props.divitm.prodOptions.length > 0 ?
                                        <ProductComboOptions
                                            product={props.divitm}
                                            PopMeUp={popMeUp}
                                            tempOrderProds={(prods) => tempOrderProds(prods)}
                                            itemId={props.itemId}
                                            imInOrder={imInOrder}
                                            removeFromOrder={() => removeFromOrder(props.itemId)}
                                            inOrderIndex={inOrderIndex}
                                            closePopup={() => setPopMeUp({ timestamp: 0, itemId: null })} />
                                        : ""
                                    :
                                    props.divitm.prodOptions.length > 0 ?
                                        <ProductOptions product={props.divitm} PopMeUp={popMeUp}
                                            tempOrderProds={(prods) => tempOrderProds(prods)}
                                            itemId={props.itemId}
                                            imInOrder={imInOrder}
                                            isMarket={true}
                                            inOrderIndex={inOrderIndex}
                                            closePopup={() => setPopMeUp({ timestamp: 0, itemId: null })} /> : ""
                                : ""
                            }
                        </> : !props.divitm.okToDeliver && <div className="notForDelivery">להזמנה במסעדה בלבד</div>}

                    <div className={"MobiPriceANdBtns"}>
                        {((!master.blockDeliverys.block || !master.blockPickUps.block) &&
                            props.divitm.okToDeliver && !isOutOfStock) &&
                            <div>
                                {(props.onlyPhone || props.myClass == null) ? "" :
                                    (!imInOrder) &&
                                    <button type="button" className={"btnReset addToOrderBtn pointing huge"}
                                        aria-label="הוסף להזמנה"
                                        style={{ display: `block` }}
                                        onClick={() => firstTimeOrdClick()}>{"+"}
                                    </button>
                                }
                                <div className={"priceln "}>
                                    ₪{(() => {
                                        if (imInOrder && props.divitm.isWeightAbleProduct) {
                                            let item = order.Orders.find(el => el.ordProdID == props.itemId && (el.orderDiviId == props.divitm._id || props.divitm._id.ObjectId));
                                            if (item?.weightValue) {
                                                return ((parseFloat(item.prodPrice) * parseFloat(item.weightValue)) / 1000).toFixed(2);
                                            }
                                        }
                                        return parseFloat(props.divitm.prodPrice).toFixed(2);
                                    })()}
                                </div>
                            </div>
                        }
                    </div>
                </div>
            </div >
        )
    }

    return (
        <div key={props.itemId} id={props.itemId} className={`${props.myClass}`} style={{ position: "relative" }}>
            {props.myClass != "" ? <div className={"overLay"}></div> : ""}

            {/* המוצר המקורי */}
            <div className={"prods"}>
                {smDisp()}
            </div>

            {/* המוצרים המשוכפלים מתחת */}
            <div className={"duplis"}>
                {duplicates}
            </div>
            {showIngredients && (
                <ProductIngredientsView
                    open={showIngredients}
                    onClose={() => setShowIngredients(false)}
                    prodName={props.divitm.prodName}
                    moreProductDetails={props.divitm.moreProductDetails}
                />
            )}
        </div>
    );
}

export default ProductItemMarket;